import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { BaseService } from 'src/app/core/services/base.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { InvoiceCreateCreditNoteWarningsDialogComponent } from '../invoice-create-credit-note-warnings-dialog/invoice-create-credit-note-warnings-dialog.component';

@Component({
  selector: 'app-invoice-create-credit-note-ledaine-dialog',
  templateUrl: './invoice-create-credit-note-ledaine-dialog.component.html',
  styleUrls: ['./invoice-create-credit-note-ledaine-dialog.component.scss']
})
export class InvoiceCreateCreditNoteLedaineDialogComponent implements OnInit {
  stores: any[] = [];
  reasons: any[] = [];
  lines = [];
  storeId: number = null;
  ledaineCreditNoteNumber: string = null;
  approvedByEmail: string = null;
  approvedByPwd: string = null;

  constructor(
    private dialogRef: MatDialogRef<InvoiceCreateCreditNoteLedaineDialogComponent>,
    private dialog: MatDialog,
    private baseService: BaseService,
    private helperService: HelperService,
    @Inject(MAT_DIALOG_DATA) public data: {
      invoiceNumber: string;
      salesOrderNumber: string;
      lines: any[];
    },
  ) { }

  ngOnInit() {
    this.lines = [];
    this.baseService.executeCommand<any>('portal_syspro_invoice_create_credit_note_ledaine_dialog_config', this.data)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.reasons = response.data.reasons;
          this.stores = response.data.stores;
          this.lines = response.data.lines;
          if (this.stores && this.stores.length === 1) {
            this.storeId = this.stores[0].storeId;
            this.storeChanged(null);
          }
        }
      });
  }

  storeChanged(event: MatSelectChange) {
  }

  createCreditNote(ignoreWarnings: boolean) {

    const dialogData: OiGroupDialogData = {
      title: 'Creating Invoice',
      function: 'portal_oi_group_invoice_create_credit_note_ledaine',
      postBody: {
        invoiceNumber: this.data.invoiceNumber,
        salesOrderNumber: this.data.salesOrderNumber,
        storeId: this.storeId,
        ledaineCreditNoteNumber: this.ledaineCreditNoteNumber,
        approvedByEmail: this.approvedByEmail,
        approvedByPwd: this.helperService.hash(this.approvedByPwd),
        ignoreWarnings: ignoreWarnings,
        lines: this.lines.filter(f => f.refundedAmount > 0).map(m => {
          return {
            stockCode: m.stockCode,
            stockDesc: m.stockDesc,
            refundedAmount: m.refundedAmount,
            returnReasonCode: m.returnReasonCode
          };
        }),
      }
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
        this.dialogRef.close(true);
      } else if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.activateOutgoingIntegration === false) {
        this.dialogRef.close(true);
        if (oiResult.data.warnings) {
          this.showWarnings(oiResult.data.warnings);
        }
      }
    });
  }

  showWarnings(warnings: any[]) {
    const ref = this.dialog.open(InvoiceCreateCreditNoteWarningsDialogComponent, {
      data: {warnings},
      width: '1000px'
    });

    ref.afterClosed().subscribe(warningsAccepted => {
      if (warningsAccepted) {
        this.createCreditNote(warningsAccepted);
      }
    });
  }

  get valid(): boolean {
    if (!this.storeId || !this.approvedByEmail || !this.approvedByPwd) {
      return false;
    }

    if (!this.ledaineCreditNoteNumber || this.ledaineCreditNoteNumber === '') {
      return false;
    }

    const negativeLines = this.lines.filter(f => f.refundedAmount < 0);
    if (negativeLines.length > 0) {
      return false;
    }

    const returnLines = this.lines.filter(f => f.refundedAmount > 0);
    if (returnLines.length === 0) {
      return false;
    }

    if (returnLines.filter(f => !f.returnReasonCode || f.returnReasonCode === '').length > 0) {
      return false;
    }

    return true;
  }

  arrayOfNumbers(n: number): number[] {
    return Array.from(Array(n + 1).keys());
  }
}
